export default __webpack_public_path__ + "static/media/AlignHorizontalChart.4a3563ee.svg";